import throttle from '../01-utils/throttle';

const listeners = [];
let lastScrollTop = window.scrollY;

// Notify all registered listeners about the scroll event
const notifyListeners = () => {
    const currentScrollTop = window.scrollY;
    const direction = currentScrollTop > lastScrollTop ? 'down' : 'up';

    if (currentScrollTop !== lastScrollTop) {
        const event = {
            direction,
            position: currentScrollTop,
            lastPosition: lastScrollTop,
        };

        listeners.forEach((callback) => callback(event));
        lastScrollTop = Math.max(currentScrollTop, 0);
    }
};

// Throttle the scroll event to avoid excessive calls
const onScroll = throttle(notifyListeners, 50);

// Attach one listener
window.addEventListener('scroll', onScroll);

/**
 * Register a scroll listener
 * @param {Function} callback
 */
export function onScrollEvent(callback) {
    listeners.push(callback);
}
